<template>
    <span 
  v-show="isShow" 
  class="inline-block rounded-full animate-spin ml-1"
  :class="customClass"
  :style="{
            width: size === 'default' ? '1.5rem' : '1rem',
            height: size === 'default' ? '1.5rem' : '1rem',
            border: `2px solid ${color}`,
            borderTopColor: 'transparent',
        }"
></span>
</template>

<script>
export default {
    name: "UiSmallLoader",
    props: {
        isShow: {
            type: Boolean,
            required: true,
            default: false,
        },
        customClass: {
            type: [String, Array, Object],
            default: null,
        },
        size: {
            type: String,
            default: 'small',
            validator: (value) => ['small', 'default'].includes(value),
        },
        light: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        color() {
            return this.light ? '#007f9f' : 'white'
        }
    }
}
</script>